import React, { useState, useRef } from 'react';
import { motion, AnimatePresence, useInView } from 'framer-motion';
import './project.css';



import { db } from "../FirebaseComp/firebase"; 
import { collection, addDoc, serverTimestamp } from "firebase/firestore";






// Reusable animated component
function AnimatedSection({ children, className }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-10% 0px" });

  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y: 30 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.7 }}
    >
      {children}
    </motion.div>
  );
}

function Project() {
  const [activeFilter, setActiveFilter] = useState('all');
  const [selectedProject, setSelectedProject] = useState(null);

  // Project data for LEARNEX
  const projects = [
    {
      id: 1,
      title: "Nexus Financial Platform",
      category: "web-app",
      description: "A comprehensive fintech dashboard for personal wealth management with real-time analytics and AI-driven insights. Built with modern React architecture and integrated with multiple financial APIs for seamless data aggregation.",
      image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
      technologies: ["React", "Node.js", "MongoDB", "D3.js", "AWS", "TensorFlow"],
      // url: "https://example.com",
      featured: true,
      client: "Global Finance Corp",
      duration: "6 months",
      results: ["40% increase in user engagement", "99.9% uptime", "30% reduction in operational costs"]
    },
{
  id: 2,
  title: "Aurora AI Assistant",
  category: "ai-ml",
  description: "An enterprise-grade conversational AI platform that integrates with business systems for automated customer support. Features natural language processing, sentiment analysis, and seamless integration with existing CRM systems.",
  image: "https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80",
  technologies: ["Python", "TensorFlow", "React", "WebSockets", "GCP", "Docker"],
  // url: "https://example.com",
  featured: true,
  client: "TechSolutions Inc",
  duration: "8 months",
  results: ["65% reduction in response time", "24/7 customer support", "45% cost savings on support staff"]
},
    {
      id: 3,
      title: "UrbanFit Mobile App",
      category: "mobile-app",
      description: "A fitness and wellness app with personalized workout plans, nutrition tracking, and community challenges. Includes AI-powered recommendations and integration with wearable devices for comprehensive health monitoring.",
      image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
      technologies: ["React Native", "Firebase", "Redux", "Apple HealthKit", "Google Fit"],
      // url: "https://example.com",
      client: "UrbanFit Wellness",
      duration: "5 months",
      results: ["500K+ downloads", "4.8-star rating", "30% monthly active users"]
    },
    {
      id: 4,
      title: "SecureGov Cloud Migration",
      category: "cloud",
      description: "Complete infrastructure migration for government agency with enhanced security protocols and zero downtime. Implemented robust disaster recovery solutions and compliance with strict government security standards.",
      image: "https://images.unsplash.com/photo-1563206767-5b18f218e8de?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
      technologies: ["AWS", "Kubernetes", "Terraform", "Python", "Jenkins", "SSL/TLS"],
      // url: "https://example.com",
      client: "National Security Agency",
      duration: "9 months",
      results: ["Zero downtime migration", "40% performance improvement", "100% compliance achieved"]
    },
    {
      id: 5,
      title: "Vision Retail Analytics",
      category: "ai-ml",
      description: "Computer vision system for retail analytics that tracks customer behavior and provides business intelligence. Delivers real-time insights into customer journeys, product interactions, and store performance metrics.",
      image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
      technologies: ["Python", "OpenCV", "TensorFlow", "React", "Azure", "Power BI"],
      // url: "https://example.com",
      client: "RetailVision Group",
      duration: "7 months",
      results: ["25% increase in sales", "Customer journey optimization", "Real-time analytics dashboard"]
    },
    {
      id: 6,
      title: "EcoConnect Sustainability Platform",
      category: "web-app",
      description: "A platform connecting sustainable businesses with consumers who want to make environmentally conscious choices. Features carbon footprint tracking, sustainable product marketplace, and educational resources.",
      image: "https://images.unsplash.com/photo-1466611653911-95081537e5b7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
      technologies: ["Vue.js", "Laravel", "MySQL", "Mapbox", "Stripe", "AWS"],
      // url: "https://example.com",
      client: "GreenWorld Initiative",
      duration: "6 months",
      results: ["10K+ sustainable products listed", "Community of 50K+ users", "Partnerships with 200+ eco-brands"]
    },
{
  id: 7,
  title: "MediTrack Healthcare System",
  category: "web-app",
  description: "Comprehensive healthcare management system for hospitals with patient records, appointment scheduling, and telemedicine capabilities. HIPAA compliant with advanced security features.",
  image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80",
  technologies: ["Angular", "Spring Boot", "PostgreSQL", "WebRTC", "Redis", "Docker"],
  // url: "https://example.com",
  client: "City General Hospital",
  duration: "10 months",
  results: ["60% faster patient processing", "Secure telemedicine platform", "Full HIPAA compliance"]
},

{
      id: 8,
      title: "LogistiChain Supply Solution",
      category: "cloud",
      description: "End-to-end supply chain management platform with real-time tracking, inventory management, and predictive analytics for logistics optimization.",
      image: "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
      technologies: ["React", "Node.js", "MongoDB", "Google Maps API", "Machine Learning", "AWS"],
      // url: "https://example.com",
      client: "Global Logistics Inc",
      duration: "8 months",
      results: ["25% reduction in delivery times", "Real-time tracking system", "Predictive inventory management"]
    }
  ];

  const categories = [
    { id: 'all', name: 'All Projects' },
    { id: 'web-app', name: 'Web Applications' },
    { id: 'mobile-app', name: 'Mobile Apps' },
    { id: 'ai-ml', name: 'AI & ML' },
    { id: 'cloud', name: 'Cloud & DevOps' }
  ];

  const filteredProjects = activeFilter === 'all' 
    ? projects 
    : projects.filter(project => project.category === activeFilter);











const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    projectTitle: "",
    projectDetails: "",
    budget: "",
    timeline: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "startyourproject"), {
        ...formData,
        createdAt: serverTimestamp(),
      });
      alert("Thank you! We’ll contact you soon.");
      setFormData({
        name: "",
        email: "",
        company: "",
        projectTitle: "",
        projectDetails: "",
        budget: "",
        timeline: "",
      });
      setIsOpen(false);
    } catch (error) {
      console.error("Error saving project:", error);
      alert("Something went wrong, please try again.");
    }
  };











  return (
    <div className="projects-container">
      {/* ===== HERO HEADER ===== */}
      <section className="projects-hero">
        <div className="hero-background">
          <div className="hero-pattern"></div>
        </div>
        <motion.div 
          className="projects-hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="hero-badge">
            <span>Showcasing Excellence</span>
          </div>
          <h1>Our <span className="gradient-text">Digital Portfolio</span></h1>
          <p className="hero-subtitle">
            Explore our curated selection of innovative projects that demonstrate our technical expertise, 
            creative problem-solving, and commitment to delivering exceptional digital solutions.
          </p>
          <div className="hero-stats">
            <div className="stat">
              <span className="stat-number">32+</span>
              <span className="stat-label">Projects Completed</span>
            </div>
            <div className="stat">
              <span className="stat-number">12+</span>
              <span className="stat-label">Industries Served</span>
            </div>
            <div className="stat">
              <span className="stat-number">99%</span>
              <span className="stat-label">Client Satisfaction</span>
            </div>
          </div>
        </motion.div>
      </section>

      {/* ===== FILTER BAR ===== */}
      <AnimatedSection className="filter-section">
        <div className="section-header">
          <h2>Browse Our Work</h2>
          <p>Filter by category to explore our diverse range of projects</p>
        </div>
        <div className="filter-container">
          {categories.map(category => (
            <motion.button
              key={category.id}
              className={`filter-btn ${activeFilter === category.id ? 'active' : ''}`}
              onClick={() => setActiveFilter(category.id)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {category.name}
            </motion.button>
          ))}
        </div>
      </AnimatedSection>

      {/* ===== PROJECTS GRID ===== */}
      <motion.section 
        className="projects-grid-section"
        layout
      >
        <AnimatePresence mode="wait">
          <motion.div 
            key={activeFilter} 
            className="grid-container"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            {filteredProjects.map(project => (
              <motion.div
                key={project.id}
                className={`project-card ${project.featured ? 'featured' : ''}`}
                layout
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.5 }}
                whileHover={{ y: -10, transition: { duration: 0.2 } }}
                onClick={() => setSelectedProject(project)}
              >
                <div className="project-image">
                  <img src={project.image} alt={project.title} />
                  <div className="project-overlay">
                    <div className="overlay-content">
                      <h3>View Case Study</h3>
                      <div className="view-project-btn">
                        <span>+</span>
                      </div>
                    </div>
                  </div>
                  {project.featured && (
                    <div className="featured-badge">
                      <span>Featured</span>
                    </div>
                  )}
                </div>
                <div className="project-info">
                  <div className="project-category">
                    {categories.find(cat => cat.id === project.category)?.name}
                  </div>
                  <h3>{project.title}</h3>
                  <p>{project.description.substring(0, 100)}...</p>
                  <div className="project-technologies">
                    {project.technologies.slice(0, 3).map((tech, index) => (
                      <span key={index} className="tech-tag">{tech}</span>
                    ))}
                    {project.technologies.length > 3 && (
                      <span className="tech-tag">+{project.technologies.length - 3}</span>
                    )}
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </AnimatePresence>
      </motion.section>

      {/* ===== PROJECT MODAL ===== */}
      <AnimatePresence>
        {selectedProject && (
          <motion.div 
            className="project-modal"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedProject(null)}
          >
            <motion.div 
              className="modal-content"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button 
                className="close-btn"
                onClick={() => setSelectedProject(null)}
              >
                &times;
              </button>

              <div className="modal-header">
                <div className="modal-image">
                  <img src={selectedProject.image} alt={selectedProject.title} />
                </div>
                <div className="modal-title-section">
                  <div className="project-meta">
                    <span className="project-category">
                      {categories.find(cat => cat.id === selectedProject.category)?.name}
                    </span>
                    <span className="project-duration">{selectedProject.duration}</span>
                  </div>
                  <h2>{selectedProject.title}</h2>
                  <p className="client-name">{selectedProject.client}</p>
                </div>
              </div>

              <div className="modal-body">
                <div className="project-details">
                  <div className="detail-section">
                    <h3>Project Overview</h3>
                    <p>{selectedProject.description}</p>
                  </div>

                  <div className="detail-section">
                    <h3>Technologies Used</h3>
                    <div className="tech-tags">
                      {selectedProject.technologies.map((tech, index) => (
                        <span key={index} className="tech-tag">{tech}</span>
                      ))}
                    </div>
                  </div>

                  <div className="detail-section">
                    <h3>Key Results</h3>
                    <ul className="results-list">
                      {selectedProject.results.map((result, index) => (
                        <li key={index}>{result}</li>
                      ))}
                    </ul>
                  </div>

                  <div className="modal-actions">
                    {/* <motion.a 
                      href={selectedProject.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="btn btn-primary project-link"
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      View Live Project
                    </motion.a> */}
                    <button 
                      className="btn btn-secondary"
                      onClick={() => setSelectedProject(null)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* ===== CTA SECTION ===== */}
      <AnimatedSection className="projects-cta">
        <div className="cta-content">
          <h2>Ready to Start Your Next Project?</h2>
          <p>Let's collaborate to create innovative solutions that drive your business forward</p>
          <div className="cta-buttons">
            
{/* Start Project Button */}
      <motion.button
        className="start-btn"
        whileHover={{
          scale: 1.05,
          boxShadow: "0 10px 25px rgba(37, 99, 235, 0.3)",
        }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setIsOpen(true)}
      >
        Start Your Project
      </motion.button>

      {/* Modal */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="modal-box"
              initial={{ scale: 0.8, opacity: 0, y: 50 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.8, opacity: 0, y: 50 }}
              transition={{ type: "spring", stiffness: 100, damping: 15 }}
            >
              {/* Close Button */}
              <button
                onClick={() => setIsOpen(false)}
                className="modal-close"
              >
                ×
              </button>

              <h2>Tell Us About Project</h2>

              <form onSubmit={handleSubmit} className="form-grid">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <input
                  type="text"
                  name="company"
                  placeholder="Company Name"
                  value={formData.company}
                  onChange={handleChange}
                />
                <input
                  type="text"
                  name="projectTitle"
                  placeholder="Project Title"
                  value={formData.projectTitle}
                  onChange={handleChange}
                  required
                />
                <textarea
                  name="projectDetails"
                  placeholder="Project Details"
                  rows="3"
                  value={formData.projectDetails}
                  onChange={handleChange}
                  required
                ></textarea>
                <input
                  type="text"
                  name="budget"
                  placeholder="Estimated Budget (LKR / USD)"
                  value={formData.budget}
                  onChange={handleChange}
                />
                <input
                  type="text"
                  name="timeline"
                  placeholder="Expected Timeline"
                  value={formData.timeline}
                  onChange={handleChange}
                />

                <motion.button
                  type="submit"
                  className="submit-btn"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  Submit Project
                </motion.button>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>













            <a href="/services" style={{ textDecoration: 'none' }}>
            <motion.button 
              className="btn btn-secondary"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              View All Services
            </motion.button></a>

          </div>
        </div>
      </AnimatedSection>
    </div>
  );
}

export default Project;